import React from 'react';
import logo from '../../imgs/logo_komity.png';

export default function Privacidad() {
    return (
        <div style={{ minHeight: '100vh', background: '#f8f9fa', fontFamily: 'system-ui, sans-serif' }}>
            <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <a href="/">
                    <img src={logo} alt="Komity" style={{ height: '32px' }} />
                </a>
            </div>
            <div style={{ maxWidth: '720px', margin: '0 auto', padding: '48px 24px' }}>
                <h1 style={{ fontWeight: 800, fontSize: '2rem', color: '#1a1a2e', marginBottom: '8px' }}>Política de Privacidad</h1>
                <p style={{ color: '#6b7280', marginBottom: '40px' }}>Última actualización: agosto 2026</p>

                {[
                    {
                        titulo: '1. Datos que recopilamos',
                        texto: 'Recopilamos: (a) datos de registro como nombre, correo electrónico y teléfono; (b) datos operativos como productos, ventas y pedidos ingresados en la plataforma; (c) datos técnicos como dirección IP y logs de acceso para seguridad y diagnóstico.',
                    },
                    {
                        titulo: '2. Uso de la información',
                        texto: 'Usamos tus datos exclusivamente para: prestar el servicio contratado, enviarte comunicaciones sobre tu cuenta (alertas de pago, actualizaciones importantes), y mejorar la plataforma. No vendemos ni cedemos tus datos a terceros con fines comerciales.',
                    },
                    {
                        titulo: '3. Almacenamiento y seguridad',
                        texto: 'Tus datos se almacenan en servidores seguros ubicados en Chile o en proveedores cloud con certificación de seguridad. Las contraseñas se almacenan encriptadas con bcrypt. Usamos HTTPS para todas las comunicaciones.',
                    },
                    {
                        titulo: '4. Datos de terceros',
                        texto: 'Si ingresas datos de tus clientes (como nombres o teléfonos en pedidos), eres responsable de contar con el consentimiento necesario de esas personas. Komity actúa como procesador de datos en ese caso.',
                    },
                    {
                        titulo: '5. Cookies y almacenamiento local',
                        texto: 'Usamos localStorage del navegador para almacenar tu sesión de forma segura. No utilizamos cookies de rastreo ni publicidad. No hay analítica de terceros que rastree tu comportamiento.',
                    },
                    {
                        titulo: '6. Tus derechos',
                        texto: 'Tienes derecho a: acceder a los datos que tenemos sobre tu negocio, corregirlos si están desactualizados, solicitar su eliminación (previa desvinculación de la cuenta), y exportar tus datos de ventas y productos en formato CSV. Para ejercer estos derechos, escríbenos a soporte@komity.cl.',
                    },
                    {
                        titulo: '7. Retención de datos',
                        texto: 'Mantenemos tus datos mientras tu cuenta esté activa. Al cancelar definitivamente el servicio, tus datos se eliminan después de 60 días, plazo que te permite recuperarlos si cambias de opinión.',
                    },
                    {
                        titulo: '8. Cambios en esta política',
                        texto: 'Avisaremos con al menos 30 días de anticipación por correo electrónico si realizamos cambios sustanciales en esta política.',
                    },
                    {
                        titulo: '9. Contacto',
                        texto: 'Para cualquier consulta sobre privacidad: soporte@komity.cl · Komity, Chile.',
                    },
                ].map((s) => (
                    <div key={s.titulo} style={{ marginBottom: '28px' }}>
                        <h2 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a1a2e', marginBottom: '8px' }}>{s.titulo}</h2>
                        <p style={{ color: '#4b5563', lineHeight: 1.7, margin: 0 }}>{s.texto}</p>
                    </div>
                ))}

                <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '24px', marginTop: '16px' }}>
                    <a href="/" style={{ color: '#7C3AED', fontWeight: 600, textDecoration: 'none', fontSize: '0.9rem' }}>← Volver al inicio</a>
                    {' · '}
                    <a href="/terminos" style={{ color: '#7C3AED', fontWeight: 600, textDecoration: 'none', fontSize: '0.9rem' }}>Términos y Condiciones</a>
                </div>
            </div>
        </div>
    );
}
